<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <g transform="translate(-899 -2562)">
      <circle class="a" cx="10" cy="10" r="10" transform="translate(900 2563)"/>
      <line class="a" y2="4" transform="translate(910 2569)"/>
      <line class="a" transform="translate(910 2577)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "WarningIcon"
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #dd227b;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
